// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from "./router"
import MetaInfo from 'vue-meta-info';
import './assets/css/style/reset.css'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$axios = axios;
Vue.config.productionTip = false
console.log('5')
Vue.prototype.$eventBus = new Vue()
Vue.use(MetaInfo);
Vue.use(ElementUI);
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  // console.log("手机端");
  // window.location.href = "https://m.yilieyun.com/"
} else {
}
//路由守卫，控制头部组件点击跳转回到页面顶部
router.beforeEach((to, from, next) => {
  const { name } = to;
  const isLoginOrRegister = (name == 'Home' || name == 'Product' || name == 'Price' || name == 'About');
  if (isLoginOrRegister) {
    // 让页面回到顶部
    document.documentElement.scrollTop = 0
    // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
    next();
  } else {
    next();
  }
})

console.log("-----2");
// console.log('000');
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // 这句非常重要，否则预渲染将不会启动
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js